import React from "react";
import "./Dashboard.scss";
import { Container, Row, Col, Form } from "react-bootstrap";
import QuickActions from "./QuickActions";
import BirthdaySlider from "./BirthdaySlider";
import Holidays from "./Holidays";
import QuickLinks from "./QuickLinks";
import { Link } from "react-router-dom";
import { config } from "../../App";

const Dashboard = ({ appAccessForUser }) => {

  const userName = sessionStorage.getItem("username");

  return (
    <section className="px-4">
      <Container fluid>

        {/* ===== First Row ===== */}

        <Row>
          <Col xl={8} lg={8} md={12} className="mb-4">
            <div className="firstSection">
              <Row>
                <Col xl={4} lg={4} md={12}>
                  <h2>
                    Hello <span>{userName}</span>
                    <span>
                      <img src="./images/icon/hey-icon.png" className="img-fluid" alt="" />
                    </span>
                  </h2>

                  <p>
                    Easily access and manage all your payroll, reimbursements,
                    and IT computations in one place.
                  </p>
                </Col>

                <Col xl={8} lg={8} md={12} className="mt-5 pt-5 mt-lg-0 pt-lg-0">
                  <ul className="internalLink">

                    <li>
                      <div class="card payslip-card text-center p-4 position-relative">

                        <div class="icon-circle bg-pink">
                          <img src="./images/icon/payslip-icon.svg" className="img-fluid" />
                        </div>

                        <h4 class="fw-bold mt-5 mb-2">PaySlip</h4>
                        <p class="text-muted mb-4">Download salary slips</p>

                        <Link to={`/paySlip`} className="btn btn-danger rounded-pill px-4">
                          View Payslips <span className="ms-3"><img src="./images/icon/arrow-icon.svg" className="img-fluid" /></span>
                        </Link>

                      </div>
                    </li>

                    <li>
                      <div class="card payslip-card text-center p-4 position-relative">

                        <div class="icon-circle bg-orange">
                          <img src="./images/icon/form-16.svg" className="img-fluid" />
                        </div>

                        <h4 class="fw-bold mt-5 mb-2">Form 16</h4>
                        <p class="text-muted mb-4">Download Tax Certificate</p>

                        <Link to={`/form16`} className="btn btn-warning text-white rounded-pill px-4">
                          View Form 16 <span className="ms-3"><img src="./images/icon/arrow-icon.svg" className="img-fluid" /></span>
                        </Link>

                      </div>
                    </li>
                  </ul>
                </Col>
              </Row>
            </div>
          </Col>

          <Col xl={4} lg={4} md={12} className="mb-4">
            <div className="announcement-box p-4">

              <h4 className="title mb-4">Latest Announcements</h4>

              <div id="announcementSlider" className="carousel slide" data-bs-ride="carousel">

                <div className="carousel-inner">
                  {/* 🌟 The Search for Our Brightest Stars Begins!

SpiceStar Awards Apr–Jun'26 nominations.

Recognize team members whose dedication, performance, and commitment have made a lasting impact.

📅 Nomination Period: 15 Jun'26 – 22 Jun'26

Nominate. Appreciate. Celebrate. 🏆 */}
                  <div className="carousel-item active">
                    <div className="announcement-card">
                      <div className="top">
                        <h6>The Search for Our Brightest Stars Begins!</h6>
                        <span></span>
                      </div>

                      <div className="line"></div>
                      <p>SpiceStar Awards Apr–Jun'26 nominations.</p>
                      <p>
                        Recognize team members whose dedication, performance, and commitment have made a lasting impact. Nomination Period: 15 Jun'26 – 22 Jun'26
                      </p>
                      <p></p>

                      <small>Nominate. Appreciate. Celebrate.</small>
                    </div>
                  </div>

                  {/* <div className="carousel-item">
                    <div className="announcement-card">
                      <div className="top">
                        <h6>New Leave Policy</h6>
                        <span>5h ago</span>
                      </div>

                      <div className="line"></div>

                      <p>
                        Company has introduced new leave rules effective next month.
                      </p>

                      <small>By HR Team</small>
                    </div>
                  </div> */}

                  {/* <div className="carousel-item">
                    <div className="announcement-card">
                      <div className="top">
                        <h6>Security Training</h6>
                        <span>1d ago</span>
                      </div>

                      <div className="line"></div>

                      <p>
                        Mandatory AVSEC security training will be conducted next week.
                      </p>

                      <small>By Training Department</small>
                    </div>
                  </div> */}

                </div>


                <div className="carousel-indicators">
                  <button type="button" data-bs-target="#announcementSlider" data-bs-slide-to="0" className="active"></button>
                  {/* <button type="button" data-bs-target="#announcementSlider" data-bs-slide-to="1"></button>
                  <button type="button" data-bs-target="#announcementSlider" data-bs-slide-to="2"></button> */}
                </div>

              </div>

              {/* <div className="text-center pt-2 w-50 m-auto announcementsImg">
                <img src="images/icon/announcements.png" className="img-fluid" />
                <p className="font-lg mt-4">Coming Soon</p>
              </div> */}

            </div>
          </Col>
        </Row>

        {/* ===== Second Row ===== */}
        <QuickActions />

        <Row>
          <Col xl={4} lg={4} md={6} className="mb-5">
            <BirthdaySlider />
          </Col>

          <Col xl={4} lg={4} md={6} className="mb-5">
            <Holidays />
          </Col>

          <Col xl={4} lg={4} md={6} className="mb-5">
            <QuickLinks />
          </Col>
        </Row>

      </Container>
    </section>
  );
};

export default Dashboard;
